var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"left-handed-icon-wrap",attrs:{"title":"Left-handed techniques"},on:{"mouseenter":_vm.showTooltip,"mouseleave":_vm.hideTooltip}},[_c('img',{staticClass:"left-handed-icon",attrs:{"src":"/images/left-handed.png","alt":"Left-handed techniques","width":"20","height":"20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }